var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.695,
    height: 15.697,
    viewBox: "0 0 15.695 15.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#9ea7b2;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.152 -47.151)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.308,
    cy: 4.308,
    r: 4.308,
    transform: "translate(50.692 50.692)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.231,
    y2: 3.231,
    transform: "translate(58.231 58.231)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.23,
    y2: 3.23,
    transform: "translate(49.078 49.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M386.692,50.692V48H384",
    transform: "translate(-324.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48,50.692V48h2.692"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.954,
    y2: 3.954,
    transform: "translate(58.046 48)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 3.954,
    y2: 3.954,
    transform: "translate(48 48)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.949,
    y1: 3.959,
    transform: "translate(58.051 58.041)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.81cbe35f79cb73f70651ee17709b7176.svg";
export { ForwardRef as ReactComponent };